import { render, staticRenderFns } from "./AtomPagination.vue?vue&type=template&id=7cb95c4c&scoped=true&"
import script from "./AtomPagination.vue?vue&type=script&lang=js&"
export * from "./AtomPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb95c4c",
  null
  
)

export default component.exports